import SamlStatus from './SamlStatus';

export default SamlStatus;
